import joinClasses from "helpers/joinClasses";
import Button from ".";

export function SecondaryButton({ className, children, onClick, ...props }) {
  return (
    <Button
      className={joinClasses("bg-secondary text-white text-[18px]", className)}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
}
